import { Controller } from "@hotwired/stimulus";
import trackEvent from "../app_proxy/trackEvent";

export default class extends Controller {
  static values = {
    name: String,
    type: String,
  };

  connect() {
    trackEvent("Page view", {
      resource_name: this.nameValue,
      resource_type: this.typeValue,
      referrer: document.referrer,
    });
  }
}
